<ng-container *transloco="let t; prefix: 'stContributionCalculator'">
    @if (calculationResult().hasSlidingPayScale) {
        <h4>{{ t('slidingPayScaleCeiling.title') }}</h4>
        <p>
            <strong>{{ t('slidingPayScaleCeiling.important') }}</strong>
        </p>
        <p>
            {{
                t('slidingPayScaleCeiling.paragraph_1', {
                    aboveSlidingPayScaleFloor: taxonomies().slidingPayScaleFloor + 0.01 | number: '1.2-2',
                    slidingPayScaleCeiling: taxonomies().slidingPayScaleCeiling | number: '1.2-2',
                })
            }}
        </p>
        <p
            [innerHTML]="
                t('slidingPayScaleCeiling.paragraph_2', {
                    number: servicePhoneNumber.title,
                })
            "></p>
    }

    @if (calculationResult().isMarginallyEmployed) {
        <h3>
            {{ t('isMarginallyEmployed.title', {slidingPayScaleFloor: taxonomies().slidingPayScaleFloor | number: '1.2-2'}) }}
        </h3>
        <p>
            <strong>
                {{ t('isMarginallyEmployed.important', {slidingPayScaleFloor: taxonomies().slidingPayScaleFloor | number: '1.2-2'}) }}
            </strong>
        </p>
        <p
            [innerHTML]="
                t('isMarginallyEmployed.paragraph_1', {
                    number: servicePhoneNumber.title,
                })
            "></p>
        <p [innerHTML]="t('isMarginallyEmployed.paragraph_2')"></p>
    }

    @if (!calculationResult().isMarginallyEmployed) {
        <h4 class="mt-10 mb-6">{{ t('results.title') }}</h4>

        <div class="font-ci text-primary text-xl dark:text-white min-w-min pb-2 md:pb-4 print:text-body">
            {{t('results.monthlyAmountYear', { year: calculationResult().year })}}
        </div>
        <big-ui-table
                [disableEvenOdd]="true"
                [rows]="monthlyAmountTableRows()"
                [renderResponsive]="true"/>

        <div class="font-ci text-primary text-xl dark:text-white min-w-min pb-2 md:pb-4 pt-4 md:pt-5 print:text-body">
            {{t('results.calculationBasis')}}
        </div>
        <big-ui-table
                class="mb-6"
                [disableEvenOdd]="true"
                [rows]="calculationBasisTableRows()"
                [renderResponsive]="true"/>

        <p class="mb-0">{{ t('results.withoutGuarantee') }}</p>
    }
</ng-container>
